import { AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { IGlobalState } from './modules/IGlobalState';

/**
 * Create strongly typed thunks.
 */
export function createThunk<A extends any[], R>(
  thunk: (
    dispatch: ThunkDispatch<IGlobalState, undefined, AnyAction>,
    getState: () => IGlobalState,
    ...args: A
  ) => R | Promise<R>,
  onError?: (
    error: any,
    dispatch: ThunkDispatch<IGlobalState, undefined, AnyAction>,
    getState: () => IGlobalState,
    ...args: A
  ) => R | Promise<R>
): (...args: A) => ThunkAction<Promise<R>, IGlobalState, undefined, AnyAction> {
  return (...args) => async (dispatch, getState) => {
    try {
      return await thunk(dispatch, getState, ...args);
    } catch (error) {
      if (onError != null) {
        return await onError(error, dispatch, getState, ...args);
      } else {
        throw error;
      }
    }
  };
}
